import { useEffect, useState } from 'react'
import { useAdminWorkflowPolicy } from './AdminWorkflowPolicyEnhancer'

function readRoute() {
  const raw = window.location.hash.replace(/^#/, '') || '/login'
  return raw.split('?')[0] || '/login'
}

function cleanupSettlementEmptyRow(route) {
  if (!/^\/settlements\/[^/]+$/.test(route)) return
  window.setTimeout(() => {
    const table = Array.from(document.querySelectorAll('.admin-content .card')).find((node) => node.querySelector('h2')?.textContent?.includes('정산 대상'))?.querySelector('table.data-table')
    if (!table) return
    const realRows = Array.from(table.querySelectorAll('tbody tr')).filter((row) => !row.querySelector('.admin-table-empty'))
    if (realRows.length) table.querySelector('tbody tr:has(.admin-table-empty)')?.remove()
  }, 0)
}

export default function AdminWorkflowBootstrap() {
  const [route, setRoute] = useState(readRoute)

  useEffect(() => {
    const onHashChange = () => setRoute(readRoute())
    window.addEventListener('hashchange', onHashChange)
    return () => window.removeEventListener('hashchange', onHashChange)
  }, [])

  useEffect(() => cleanupSettlementEmptyRow(route), [route])
  useAdminWorkflowPolicy(route)
  return null
}
